/**
 * Create an event and attach data to it
 * @param event
 * @param data
 * @returns {Event}
 */
export const createEvent = (event: any, data: any = {}) => {
    if (typeof event === 'string') {
        return new Event(event, data);
    }

    event.data = data;

    return event;
};
